const STEPS = ['Your problem', 'AI Discovery Questions', 'Your result'];

interface StepperProps {
  /** 0-based index of the current step. */
  active: number;
}

export function Stepper({ active }: StepperProps): React.JSX.Element {
  return (
    <ol className="tbo-stepper" aria-label="Progress">
      {STEPS.map((label, i) => {
        const state = i < active ? 'done' : i === active ? 'active' : 'todo';
        return (
          <li key={label} className={`tbo-step is-${state}`}>
            <span className="tbo-step-dot" aria-hidden="true">
              {state === 'done' ? '✓' : i + 1}
            </span>
            <span className="tbo-step-label">{label}</span>
          </li>
        );
      })}
    </ol>
  );
}
